<template>
  <div class="container container-sites">
    <div class="row">
      <div class="col">
        <button class="btn btn-primary mb-4" @click="openModal()">Create new site </button>
      </div>
      <div class="col btn-switcher-mode">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="isLiveMode">
          <label class="form-check-label" for="flexSwitchCheckDefault">{{isLiveMode ? 'Live mode' : 'Test mode'}}</label>
        </div>
      </div>
    </div>

    <table class="table table-bordered">
      <div v-show="sitesLoading" class="pro-shadow">
        <div class="pro-spinner animate size-36"></div>
      </div>
      
      <thead class="table-light">
        <tr>
          <th scope="col">#</th>
          <th scope="col">Name</th>
          <th scope="col">Default domain</th>
          <th scope="col">External domain</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody v-if="sites && sites.length > 0">
        <tr v-for="(item, index) in sites" :key="item.name">
          <td>{{index+1}}</td>
          <td>{{item.title}}</td>
          <td>
            <a v-if="item.system_url" :href="item.system_url" target="_blank">{{item.system_url}}</a>
            <span v-else>-</span>
          </td>
          <td class="td-external-domain">
            <div v-if="item.custom_url" class="external-domain-block">
              <font-awesome-icon v-if="item.custom_domain_is_verified" icon="fa-solid fa-check" />
              <font-awesome-icon v-else icon="fa-solid fa-triangle-exclamation" title="DNS record was not verified yet" />
              <a :href="item.custom_url" target="_blank">{{item.custom_url}}</a>
            </div>
            <div v-else style="text-align: center">-</div>
          </td>
          <td class="actions">
            <button
              type="button"
              class="button-actions"
              title="View analytics"
              @click="toMatomoStat(item)"
            >
              View analytics
            </button>
            <br>
            <button
              type="button"
              class="button-actions"
              title="Edit Site"
              @click="editTemplate(item)"
            >
              Edit Site
            </button>
            <br>
            <button
              type="button"
              class="button-actions"
              title="Edit Page"
              @click="toEditTemplate(item)"
            >
              Edit Page
            </button>
            <br>
            <button
              type="button"
              class="button-actions"
              title="Edit Page"
              @click="deleteSite(item.storageZoneId)"
            >
              Delete Site
            </button>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr class="empty-list">
          <td colspan="10">Site list is empty</td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="showModal"
      class="modal fade show"
      style="display: block; background: rgba(0,0,0, .4)"
      id="exampleModal"
      tabindex="-1"
      ria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              
              <span v-if="idEditTemplate">Update site</span>
              <span v-else>
                {{ siteResponse ? 'Setup DNS' : 'Create new site'}}
              </span>
            </h5>
            <button type="button" class="btn-close" @click="openModal()" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form v-if="!showCNAMEinfo" class="form" :class="{'was-validated': wasValidated}">
              <div class="mb-3">
                <label for="saitName" class="form-label mb-1">Site name:</label>
                <div class="input-group has-validation">
                  <input type="text" class="form-control" id="saitName" v-model="formDataName" required>
                  <div class="invalid-feedback">
                    Please choose a name.
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="saitMixpaneToken" class="form-label mb-1">Mixpanel token:</label>
                <div class="input-group has-validation">
                  <input type="text" class="form-control" id="saitMixpaneToken" v-model="formDataToken">
                  <div class="invalid-feedback">
                    Enter your project token.
                  </div>
                </div>
              </div>
              <div class="mb-3">

                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="formDataMatomo" v-model="formDataMatomo">
                  <label class="form-check-label" for="formDataMatomo">{{formDataMatomo ? 'ON Matomo' : 'OFF Matomo'}}</label>
                </div>

                <!-- <label for="saitMixpaneToken" class="form-label mb-1">Use Matomo:</label>
                <div class="input-group has-validation">
                  <input type="text" class="form-control" id="saitMixpaneToken" v-model="formDataMatomo">
                </div> -->
              </div>
              <div class="mb-3" v-if="!idEditTemplate">
                <label for="saitDomain" class="form-label mb-1">Domain type:</label>
                <select
                  class="form-select form-select"
                  aria-label=".form-select example"
                  v-model="formDataDomainType"
                  name="domain-type"
                  required
                >
                  <option value="default" selected>Default only</option>
                  <option value="custom">Use my own domain</option>
                  <option value="new">Buy a new domain</option>
                </select>
                <div class="invalid-feedback">
                    Please choose a domain type.
                  </div>
              </div>
              <div class="mb-3" v-if="!idEditTemplate && formDataDomainType === 'custom'">
                <label for="saitDomain" class="form-label mb-1">Domain name:</label>
                <input type="text" class="form-control" id="saitDomain" v-model="formDataDomain" required>
                <div class="invalid-feedback">
                    Please choose a domain.
                  </div>
              </div>
              <div class="mb-3" v-if="!idEditTemplate">
                <label class="form-label mb-1">Select template:</label>
                <div class="templates">
                  <div class="input-group">
                    <input type="radio" id="fake-radio-1" class="fake-radio-btn" name="radio-temp" v-model="template" value="1" required>
                    <label class="fake-radio" for="fake-radio-1">
                      <img class="fake-radio__image" src="../assets/img/1-template.png" alt="">
                    </label>
                  </div>

                  <div class="input-group">
                    <input type="radio" id="fake-radio-2" class="fake-radio-btn" name="radio-temp" v-model="template" value="2" required>
                    <label class="fake-radio" for="fake-radio-2">
                      <img class="fake-radio__image" src="../assets/img/2-template.png" alt="">
                    </label>
                  </div>

                  <div class="input-group">
                    <input type="radio" id="fake-radio-3" class="fake-radio-btn" name="radio-temp" v-model="template" value="3" required>
                    <label class="fake-radio" for="fake-radio-3">
                      <img class="fake-radio__image" src="../assets/img/3-template.png" alt="">
                    </label>
                  </div>

                  <div class="input-group">
                    <input type="radio" id="fake-radio-4" class="fake-radio-btn" name="radio-temp" v-model="template" value="4" required>
                    <label class="fake-radio" for="fake-radio-4">
                      <img class="fake-radio__image" src="../assets/img/4-template.png" alt="">
                    </label>
                  </div>
                  <div class="input-group">
                    <input type="radio" id="fake-radio-5" class="fake-radio-btn" name="radio-temp" v-model="template" value="5" required>
                    <label class="fake-radio" for="fake-radio-5">
                      <img class="fake-radio__image" src="../assets/img/5-template.png" alt="">
                    </label>
                  </div>
                  <div class="input-group">
                    <input type="radio" id="fake-radio-6" class="fake-radio-btn" name="radio-temp" v-model="template" value="6" required>
                    <label class="fake-radio" for="fake-radio-6">
                      <img class="fake-radio__image" src="../assets/img/6-template.png" alt="">
                    </label>
                  </div>
                </div>
                
                
                <!-- <input type="radio" class="fake-radio-btn" name="radio-temp" v-model="template" value="second" required> -->
                <!-- <div class="invalid-feedback">Please select template</div> -->
              </div>
            </form>
            <div v-if="siteResponse">
              <h6>Please add the following CNAME record to the DNS settings of your domain</h6>
              <ul>
                <li><strong>Type:</strong> CNAME</li>
                <li><strong>Name:</strong> {{formDataDomain ? formDataDomain : siteResponse.custom_url}}</li>
                <li><strong>Value:</strong> {{siteResponse.system_url.replace('https://', '')}}</li>
              </ul>
            </div>

            <div v-if="checkDnsMsg" class="alert" :class="checkDnsMsg.type" role="alert">
              {{checkDnsMsg.msg}}
            </div>
            
          </div>
          <div class="modal-footer">
            <button
              v-if="siteEdit"
              type="button"
              class="btn btn-primary btn-buy-from-edit"
              @click="buyDomainFromEdit()"
            >Buy a new domain</button>
            <button
              v-if="siteResponse"
              type="button"
              class="btn btn-primary"
              :class="{'loading-b': checkDNSLoading}"
              :disabled="checkDNSLoading || createLoader"
              @click="confirmDNS()"
            >Confirm and verify DNS</button>
            <button type="button" class="btn btn-secondary" @click="openModal()">Close</button>
            <button
              v-if="idEditTemplate"
              type="button"
              class="btn btn-primary"
              :class="{'loading-b': createLoader}"
              :disabled="isDisabled"
              @click="updateSite()"
            >Update site</button>
            <button
              v-else-if="!siteResponse"
              type="button"
              class="btn btn-primary"
              :class="{'loading-b': createLoader}"
              :disabled="isDisabled"
              @click="createSite()"
            >Create site</button>
          </div>
        </div>
      </div>
    </div> <!-- End Fisrt Modal -->

    <div
      v-if="newDomainModal"
      class="modal fade show"
      style="display: block; background: rgba(0,0,0, .4)"
      id="newDomainModal"
      tabindex="-1"
      ria-labelledby="newDomainModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="newDomainModalLabel">
              By new domain
            </h5>
            <button type="button" class="btn-close" @click="openModal(false, 'second')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form class="form form-buy-data" v-if="isBuyDomain">
              <div class="row">
                <div class="col-12 col-lg-6 mb-3">
                  <label for="card-type" class="form-label mb-1">Card Type:</label>
                  <div class="input-group">
                    <select
                      id="card-type"
                      class="form-select"
                      aria-label=".form-select example"
                      v-model="buyFormCardType"
                      name="domain-type"
                    >
                      <option value="Visa" selected>Visa</option>
                      <option value="Mastercard">Mastercard</option>
                      <option value="AmEx">AmEx</option>
                      <option value="Discover">Discover</option>
                    </select>
                  </div>
                  
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="card-owner" class="form-label mb-1">Card owner:</label>
                  <div class="input-group has-validation">
                    <input type="text" class="form-control" id="card-owner" v-model="buyFormCardOwner">
                  </div>
                </div>
                
                <div class="col-12 col-lg-6 mb-3">
                  <label for="card-number" class="form-label mb-1">Card Number:</label>
                  <div class="input-group has-validation">
                    <input type="text" class="form-control" id="card-number" v-model="buyFormCardNumber">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="month" class="form-label mb-1">Expiration month / year:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="Month" id="month" placeholder="month" v-model="buyFormMonth">
                    <input type="text" class="form-control" aria-label="Year" id="year" placeholder="year" v-model="buyFormYear">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="cvv2" class="form-label mb-1">CVV2:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="CVV2" id="cvv2" v-model="buyFormCvv2">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="bill-address" class="form-label mb-1">Billing Address:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="Billing Address" id="bill-address" v-model="buyFormAddress">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="city" class="form-label mb-1">City:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="City" id="city" v-model="buyFormCity">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="state-prov" class="form-label mb-1">State/Province:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="State/Province" id="state-prov" v-model="buyFormState">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="zip-code" class="form-label mb-1">Zip code:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="Zip code" id="zip-code" v-model="buyFormZipCode">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="country" class="form-label mb-1">Country:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="Country" id="country" v-model="buyFormCountry">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="phone-number" class="form-label mb-1">Phone number:</label>
                  <div class="input-group">
                    <input type="tel" class="form-control" aria-label="Phone number" id="phone-number" v-model="buyFormPhone">
                  </div>
                </div>

                <div class="modal-line"></div>

                <div class="col-12 col-lg-6 mb-3">
                  <label for="reg-first-name" class="form-label mb-1">First name:</label>
                  <div class="input-group has-validation">
                    <input type="text" class="form-control" id="reg-first-name" v-model="buyFormRegFirstName">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="reg-last-name" class="form-label mb-1">Last name:</label>
                  <div class="input-group has-validation">
                    <input type="text" class="form-control" id="reg-last-name" v-model="buyFormRegLastName">
                  </div>
                </div>

                <div class="col-12 col-lg-6 mb-3">
                  <label for="adress1" class="form-label mb-1">Address:</label>
                  <div class="input-group has-validation">
                    <input type="text" class="form-control" id="adress1" v-model="buyFormRegAddress1">
                  </div>
                </div><div class="col-12 col-lg-6 mb-3">
                  <label for="reg-city" class="form-label mb-1">City:</label>
                  <div class="input-group has-validation">
                    <input type="text" class="form-control" id="reg-city" v-model="buyFormRegCity">
                  </div>
                </div><div class="col-12 col-lg-6 mb-3">
                  <label for="postal" class="form-label mb-1">Postal:</label>
                  <div class="input-group has-validation">
                    <input type="text" class="form-control" id="postal" v-model="buyFormRegPostal">
                  </div>
                </div><div class="col-12 col-lg-6 mb-3">
                  <label for="reg-country" class="form-label mb-1">Country:</label>
                  <div class="input-group has-validation">
                    <input type="text" class="form-control" id="reg-country" v-model="buyFormRegCountry">
                  </div>
                </div>

                <div class="col-12 col-lg-6 mb-3">
                  <label for="reg-email" class="form-label mb-1">Email:</label>
                  <div class="input-group">
                    <input type="tel" class="form-control" aria-label="Email" id="reg-email" v-model="buyFormRegEmail">
                  </div>
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label for="reg-phone" class="form-label mb-1">Phone:</label>
                  <div class="input-group">
                    <input type="tel" class="form-control" aria-label="Phone" id="reg-phone" v-model="buyFormRegPhone">
                  </div>
                </div>
                
              </div>
              
            </form>

            <form class="form" v-else>
              <div class="mb-3">
                <label for="saitName" class="form-label mb-1">Domain name:</label>
                <div class="input-group has-validation">
                  <input type="text" class="form-control" id="saitName" v-model="newDomain" required>
                  <button
                    class="btn btn-primary"
                    type="button"
                    id="button-addon2"
                    :class="{'loading-b': loaderSearchDomain}"
                    :disabled="!newDomain || loaderSearchDomain"
                    @click="checkDomain()"
                  >Search Domain</button>
                </div>
              </div>
            </form>

            <div v-if="checkDnsMsg" v-html="checkDnsMsg.msg" class="alert" :class="checkDnsMsg.type" role="alert">
            </div>

            <!-- <ul class="domain-list" v-if="suggestionsDomain && this.newDomainResponse && !this.newDomainResponse.available"> -->
            <!-- <button class="btn btn-primary btn-sm" @click="checkEveryDomain()">Check Async</button> test button-->
            <ul class="domain-list" v-if="suggestionsDomain">
              <li class="domain-list__item" v-for="(item, index) in suggestionsDomain" :key="item.domain+index">
                <span class="text-domain">{{item.domain}}</span>
                <div class="domain-list__item-price">
                  <div v-if="item.status === 'checking'">
                    <div class="pro-spinner animate size-12"></div>
                    <span class="text-secondary">Checking availability...</span>
                  </div>

                  <span v-if="item.status === 'taken'" class="text-warning">Domain taken</span>
                  
                  <strong  v-if="item.status === 'available'">${{item.price}}</strong>

                  <button class="btn btn-primary btn-sm" @click="buyDomain(item.domain)" :disabled="item.status !== 'available'">Buy</button>
                </div>
              </li>
              <!-- <li class="domain-list__item loader-sugges" v-show="suggestionsLoader">
                <div class="pro-shadow">
                  <div class="pro-spinner animate size-36"></div>
                </div>
              </li> -->
            </ul>
            
          </div>
          <div class="modal-footer">
            <button
              v-if="isBuyDomain"
              type="button"
              class="btn btn-primary btn-test-data"
              @click="this.setTestData()"
            >Set Test Data</button>
            <button type="button" class="btn btn-secondary" @click="openModal(false, 'second')">Close</button>
            <button
              v-if="isBuyDomain"
              type="button"
              class="btn btn-primary"
              :class="{'loading-b': loaderBuyDomain}"
              :disabled="loaderBuyDomain"
              @click="this.purchaseDomain()"
            >Purchase domain</button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              :class="{'loading-b': createLoader}"
              :disabled="isDisabledByDomain"
              @click="this.buyDomain()"
            >Buy domain</button>
          </div>
        </div>
      </div>
    </div> <!-- End Second Modal -->

  </div>
</template>

<script>
import {sitesService} from "@/_api/sites.api";

export default {
  naem: 'SitesView',
  props: {},
  components: {},
  data() {
    return {
      sites: [],
      showModal: false,
      formDataName: null,
      formDataToken: null,
      formDataMatomo: false,
      formDataDomainType: null,
      formDataDomain: null,
      template: null,
      showCNAMEinfo: false,
      siteResponse: null,
      checkSiteResponse: null,
      wasValidated: false,
      sitesLoading: false,
      checkDNSLoading: false,
      createLoader: false,
      idEditTemplate: null,
      siteEdit: null,
      siteEditTemplateId: null,
      showCheckDnsBtn: false,
      checkDnsMsg: null,
      showErrors: {
        name: false,
        domain: false,
        template: false
      },
      hostSite: window.location.protocol +'//'+window.location.host,
      //New domanin vars
      isLiveMode: false,
      newDomainModal: false,
      newDomain: null,
      newDomainResponse: null,
      isDisabledByDomain: true,
      loaderSearchDomain: false,
      loaderBuyDomain: false,
      isBuyDomain: false,
      siteResponseBuy: null,
      suggestionsDomain: null,
      // suggestionsDomainsChecked: null,
      suggestionsLoader: false,
      stopCheckDomains: false,
      // suggestionsDomain: [
      //       {
      //           "domain": "OlehsNihA.net",
      //           "price": 39.95
      //       },
      //       {
      //           "domain": "Olehs-Nih-A.com",
      //           "price": 39.95
      //       },
      //       {
      //           "domain": "Olehs-Nih-A.net",
      //           "price": 39.95
      //       },
      //       {
      //           "domain": "OlehsNihA.bar",
      //           "price": 84.99
      //       },
      //       {
      //           "domain": "OlehsNihA.car",
      //           "price": 3499.99
      //       },
      //       {
      //           "domain": "OlehsNihA.yoga",
      //           "price": 34.99
      //       },
      //       {
      //           "domain": "OlehsNihA.dental",
      //           "price": 59.99
      //       }
      // ],
      //form vars
      buyFormCardType: null,
      buyFormCardOwner: null,
      buyFormCardNumber: null,
      buyFormMonth: null,
      buyFormYear: null,
      buyFormCvv2: null,
      buyFormAddress: null,
      buyFormCity: null,
      buyFormState: null, //State/Province
      buyFormZipCode: null,
      buyFormCountry: null,
      buyFormPhone: null,
      buyFormEmail: null,

      buyFormRegFirstName: null,
      buyFormRegLastName: null,
      buyFormRegAddress1: null,
      buyFormRegCity: null,
      buyFormRegPostal: null,
      buyFormRegCountry: null,
      buyFormRegEmail: null,
      buyFormRegPhone: null,

      buyFormValidErrors: null
    }
  },
  computed: {
    isDisabled() {
      // evaluate whatever you need to determine disabled here...
      if (!this.idEditTemplate) {
        if (this.formDataDomainType === 'default' || this.formDataDomainType === 'new') {
          return this.formDataName && this.template && !this.createLoader ? false : true;
        } else {
          return this.formDataName && this.formDataDomain && this.template && !this.createLoader ? false : true;
        }
        
      } else {
        return this.formDataName && !this.createLoader ? false : true;
      }
    },
    buyValidation() {
      if (
        this.buyFormCardType
        && this.buyFormCardOwner
        && this.buyFormCardNumber
        && this.buyFormMonth
        && this.buyFormYear
        && this.buyFormCvv2
        && this.buyFormAddress
        && this.buyFormCity
        && this.buyFormState
        && this.buyFormZipCode
        && this.buyFormCountry
        && this.buyFormPhone
        && this.buyFormRegFirstName
        && this.buyFormRegLastName
        && this.buyFormRegAddress1
        && this.buyFormRegCity
        && this.buyFormRegPostal
        && this.buyFormRegCountry
        && this.buyFormRegEmail
        && this.buyFormRegPhone
      ) {
        return true
      } else {
        return false;
      }
    }
  },
  created() {

  },
  mounted() {
    this.getSites();
    // localStorage.clear();
    localStorage.removeItem("gjsProject");
    localStorage.removeItem("gjpTemplaeteId");
  },
  beforeUnmount() {

  },
  watch: {
    visible: function(newVal, oldVal) {
      this.showModal = newVal;
      console.log('dddddddddd', newVal, oldVal)
    }
  },
	methods: {
    getSites() {
      this.sitesLoading = true;
			sitesService.getSites().then((res) => {
        this.sitesLoading = false;
        this.sites = res.data;
        // let sorted = this.sites.sort((a, b) => {
        //   return b.storageZoneId - a.storageZoneId
        // })
				// console.log('getSites response', res.data)
			}).catch((err) => {
        this.sitesLoading = false;
        console.log('getSites ERROR!!!', err)
      });
		},
    getSingleSite() {

      if (this.idEditTemplate) {
        this.createLoader = true;
        sitesService.getSite({storageZoneId: this.idEditTemplate}).then((res) => {
          this.createLoader = false;
          this.siteEdit = res.data;
          if (res.data.custom_url) {
            this.siteResponse = res.data;
            // this.showCheckDnsBtn
          }
          // console.log('getSites response', res.data)
        }).catch((err) => {
          this.createLoader = true;
          console.log('Error!!!', err)
        });
      }
		},
    toEditTemplate(item) {
			this.$router.replace({
				// path:`/site/builder/${item.storageZoneId}`,
				path:`builder/${item.storageZoneId}`,
			});
      let tempId = item.template_id ? item.template_id : 1;
      localStorage.setItem("gjpTemplaeteId", tempId);
      // localStorage.setItem("gjpTemplaeteId", 1);
		},
    toMatomoStat(item) {
      console.log('UUUUUUU', item)
			this.$router.replace({
				path:`stat/${item.storageZoneId}`,
				// path:`/stat/${item.storageZoneId}`,
        query: { siteName: item.title}
			});
		},
    editTemplate(data) {
      console.log('ddddddddd',data)
      if (data) {
        this.openModal(data);
        this.formDataName = data.title;
        this.formDataToken = data.token;
        this.siteEditTemplateId = data.template_id
        this.idEditTemplate = data.storageZoneId;
        this.getSingleSite();
      }
    },
    toogleModals() {
      this.openModal(false);
      setTimeout(() => {
        this.openModal(true, 'second');
      }, 300);
    },
    openModal(data, type = 'first') {

      if (type === 'first') {
        if (data !== undefined) {
          this.showModal = data;
        } else {
          this.showModal = !this.showModal;
        }
        if (!this.showModal) {
          this.formDataName = null;
          this.formDataToken = null;
          this.formDataMatomo = false;
          this.formDataDomainType = null;
          this.formDataDomain = null;
          this.template = null;
          this.idEditTemplate = null;
          this.showCNAMEinfo = false;
          this.checkSiteResponse = null;
          this.checkDNSLoading = false;
          this.checkDnsMsg = null;
          this.siteEditTemplateId = null;
          this.siteResponse = null;
          if (!data) this.createLoader = false;
        }
      } else if (type === 'second') {

        if (data !== undefined) {
          this.newDomainModal = data;
        } else {
          this.newDomainModal = !this.newDomainModal;
        }
        if (!this.newDomainModal) {
          if (!data) this.loaderBuyDomain = false;
          this.setTestData('reset')
          this.newDomain = null;
          this.checkDnsMsg = null;
          this.siteResponseBuy = null;
          this.isBuyDomain = false;
          this.suggestionsDomain = null;
          this.suggestionsDomainsChecked = null;
          this.stopCheckDomains = false;
          this.suggestionsLoader = false;
        }

      }

    },
    setData($event) {
      console.log('SEtData!', $event)
    },
    createSite() {
      // this.wasValidated = true;
      let sendObj = {
        title: this.formDataName,
        domain_type: this.formDataDomainType,
        use_matomo: this.formDataMatomo,
        custom_domain: this.formDataDomain,
        template_id: Number(this.template)
      }
      if (this.formDataToken) {
        sendObj['mixpanel_token'] = this.formDataToken;
      }
      console.log('Send data!!!', sendObj);
      this.createLoader = true;

      sitesService.createSite(sendObj).then((res) => {
        // this.openModal(false);
        console.log('createSite', res);

        if (this.formDataDomainType === 'custom') {
          this.showCNAMEinfo = true;
          this.siteResponse = res.data.data;
          this.createLoader = false;
          // this.isDisabled = true;
        } else if (this.formDataDomainType === 'new') {
          this.siteResponseBuy = res.data.data;
          this.createLoader = false;
          this.toogleModals();
        } else {
          this.openModal(false);
        }

        if (res.data.status === "success") {
          this.getSites();
        }
      }).catch((err) => {
        // this.openModal(false);
        if (err.response.data.message) {
          // this.checkDnsMsg = err.response.data.message;
          this.showAlertMsg(err.response.data.message, 'alert-danger')
          setTimeout(() => {
            this.createLoader = false;
            this.checkDnsMsg = null;
          }, 2000)
        }
        // console.log('createSite ERROR!!!', err)
      });
    },
    updateSite() {
      let sendObj = {
        title: this.formDataName,
        template_id: this.siteEditTemplateId ? this.siteEditTemplateId : 1,
        mixpanel_token: this.formDataToken,
        use_matomo: this.formDataMatomo,
        body: this.siteEdit.html.body,
        style: this.siteEdit.html.style,
      }
      console.log('Send data!!!', sendObj, this.siteEdit.url);
      this.createLoader = true;

      if (this.idEditTemplate && this.siteEdit) {
        sitesService.updateSite(this.idEditTemplate, sendObj).then((res) => {
          this.openModal(false);
          console.log('updateSite', res);

          if (res.data.status === "success") {
            this.getSites();
          }
        }).catch((err) => {
          // this.openModal(false);
            if (err.response.data.data.domain)
           if (err.response.data.message) {
            // this.checkDnsMsg = err.response.data.message;
            this.showAlertMsg(err.response.data.message, 'alert-danger')
            setTimeout(() => {
              this.createLoader = false;
              this.checkDnsMsg = null;
            }, 2000);
          }
          console.log('updateSite ERROR!!!', err)
        });
      }
    },
    deleteSite(id) {
      let confResult = confirm('Are you sure you want to delete the site?');
      if (confResult) {
        sitesService.deleteSite(id).then((res) => {
          console.log('deleteSite', res);

          if (res.data.status === "success") {
            this.getSites();
          }
        }).catch((err) => {
          console.log('deleteSite ERROR!!!', err)
        });
      }
    },
    confirmDNS() {
      if (this.siteResponse) {
        this.checkDNSLoading = true;
        sitesService.confirmDNS(this.siteResponse.storageZoneId).then((res) => {
        // this.openModal(false);
        this.checkDNSLoading = false;
        console.log('confirmDNS', res);
        if (res.data.data) {
          this.showAlertMsg('DNS record was successful verified', 'alert-success')
        } else {
          this.showAlertMsg('DNS record was not verified yet', 'alert-warning')
        }
        this.checkSiteResponse = res.data.data;
        if (res.data.status === "success") {
          this.getSites();
        }
      }).catch((err) => {
        // this.openModal(false);
        this.checkDNSLoading = false;
        if (err.response.data.message) {
          // this.checkDnsMsg = err.response.data.message;
          this.showAlertMsg(err.response.data.message, 'alert-danger')
        }
        console.log('confirmDNS ERROR!!!', err)
      });
      }
    },
    checkEveryDomain() {
      // console.log('OKOKOKOKOKOKO')
      let count = 0;

      let checkDomainLoc = (domainName = null, index) => {
        this.suggestionsLoader = true;
        let sendData = {
          domain: domainName,
          ['enom-live']: this.isLiveMode,
          ['hide-suggestions']: true
        }
        sitesService.checkNewDomain(sendData).then((res) => {
          if (res.data.data.available) {
            this.suggestionsDomain[index].status = 'available';
          } else {
            this.suggestionsDomain[index].status = 'taken';
          }
          // console.log('qqqqqqqqqqqq', JSON.parse(JSON.stringify(res.data.data)))
          // if (res.data.data.available) {
          //   let dataDomain = {
          //     ...res.data.data,
          //     domain: domainName
          //   }; 
          //   if (this.suggestionsDomainsChecked) {
          //     this.suggestionsDomainsChecked = [
          //       ...this.suggestionsDomainsChecked,
          //       dataDomain
          //     ]
          //   } else {
          //     this.suggestionsDomainsChecked = [dataDomain]
          //   }
            
          // }
          // // console.log('dddddddd', this.suggestionsDomainsChecked[count])
          // if (count < this.suggestionsDomain.length && !this.stopCheckDomains && this.newDomainModal) {
          //   if (this.suggestionsDomain[count]) {
          //     checkDomainLoc(this.suggestionsDomain[count].domain);
          //   }
          // } else {
          //   this.suggestionsLoader = false;
          // }
          
        }).catch((err) => {
          // this.openModal(false);
          // this.suggestionsLoader = false;
          console.log('checkNewDomain ERROR!!!', err);
        });
      }

      let intervalReq = setInterval(() => {
        
        
        if (!this.isBuyDomain && count < this.suggestionsDomain.length) {
          checkDomainLoc(this.suggestionsDomain[count].domain, count);
          count++
        } else {
          clearInterval(intervalReq);
        }

        // if (countRequest <= 4) {
        //   for (let i = count; i < this.suggestionsDomain.length; i++) {
        //     console.log('before breack', i);
        //     if (countRequest >=4 ) break;
        //     console.log('after breack', i);
        //     if (i < this.suggestionsDomain.length) {
        //       count++
        //       checkDomainLoc(this.suggestionsDomain[i].domain, i);
        //     } else {
        //       clearInterval(intervalReq);
        //     }
            
        //     // this.suggestionsDomain[i]
        //   }
        // }
        // console.log('Interval', count, countRequest)
      }, 800);
      if (this.suggestionsDomain && this.suggestionsDomain[count]) {
        checkDomainLoc(this.suggestionsDomain[count].domain, count);
      }
      // if (this.suggestionsDomain) {
      //   checkDomainLoc();
      // }
    },
    checkDomain(hideAvailable = false) {
      // console.log('Type MODE!!!!!!!!!!', this.isLiveMode)
      if (this.newDomain) {
        let sendData = {
          domain: this.newDomain,
          ['enom-live']: this.isLiveMode,
          ['hide-suggestions']: hideAvailable
        }
        this.loaderSearchDomain = true;
        this.suggestionsDomainsChecked = null;
        sitesService.checkNewDomain(sendData).then((res) => {
          // this.openModal(false);
          if (hideAvailable) {
            console.log(hideAvailable)
          } else {
            this.loaderSearchDomain = false;
            if (res.data.data.suggestions) {
              let tempArr = res.data.data.suggestions.map((item) => {
                item['status'] = 'checking'; // 'available', 'taken'
                return item;
              });
              this.suggestionsDomain = tempArr;

              this.checkEveryDomain()
            }
            console.log('checkNewDomain', res);
            this.newDomainResponse = res.data.data;
            if (this.newDomainResponse.available) {
              this.showAlertMsg('Your domain is available! Domain price <strong>$'+this.newDomainResponse.price+'</strong>', 'alert-success')
              this.isDisabledByDomain = false;
            } else {
              this.showAlertMsg('Domain taken! You can select an available domain from the list', 'alert-warning');
              this.isDisabledByDomain = true;
            }
          }
          
        }).catch((err) => {
          // this.openModal(false);
          this.loaderSearchDomain = false;
          if (err.response.data.message) {
            this.showAlertMsg(err.response.data.message, 'alert-danger')
          }
          console.log('checkNewDomain ERROR!!!', err)
        });
      }
      
    },
    buyDomainFromEdit() {
      if (this.siteEdit) {
        console.log('dddddddddd', this.siteEdit.title);
        this.siteResponseBuy = {
          title: this.siteEdit.title,
          system_url: this.siteEdit.system_url,
          custom_url: this.siteEdit.custom_url,
          storageZoneId: this.siteEdit.storageZoneId,
          template_id: this.siteEdit.template_id
        };
        this.toogleModals();
      }
    },
    buyDomain(domain = null) {
      this.isBuyDomain = true;
      this.checkDnsMsg = null;
      this.suggestionsDomain = null;
      this.stopCheckDomains = true;
      // console.log('wwwwwwwwwww', this.newDomainResponse)
      if (domain && !this.newDomainResponse.available) {
        this.newDomain = domain;
      }
      
    },
    purchaseDomain() {
      const sendData = {
        domain: this.newDomain,
        ['enom-live']: this.isLiveMode,
        ['credit-card']: {
          type: this.buyFormCardType,
          owner: this.buyFormCardOwner,
          // ['first-name']: this.buyFormFirstName,
          // ['last-name']: this.buyFormLastName,
          number: this.buyFormCardNumber,
          ['exp-month']: this.buyFormMonth,
          ['exp-year']: this.buyFormYear,
          cvv2: this.buyFormCvv2,
          address: this.buyFormAddress,
          city: this.buyFormCity,
          state: this.buyFormState,
          zip: this.buyFormZipCode,
          phone: this.buyFormPhone,
          country: this.buyFormCountry,
        },
        ["registrant"]: {
          ["first-name"]: this.buyFormRegFirstName,
          ["last-name"]: this.buyFormRegLastName,
          address1: this.buyFormRegAddress1,
          city: this.buyFormRegCity,
          postal: this.buyFormRegPostal,
          country: this.buyFormRegCountry,
          email: this.buyFormRegEmail,
          phone: this.buyFormRegPhone
        }
      }

      console.log('SEND DATA!', sendData)

      if (this.buyValidation && this.newDomain && this.siteResponseBuy) {
        this.loaderBuyDomain = true;
        console.log('Send Data purchaseDomain', sendData);

        sitesService.buyNewDomain(this.siteResponseBuy.storageZoneId, sendData).then((res) => {
          // this.openModal(false);
          this.checkDnsMsg = null;
          // this.newDomainResponse = res.data.data;
          if (res.data.data) {
            this.showAlertMsg('Domain successfully purchased', 'alert-success');
            setTimeout(() => {
              this.loaderBuyDomain = false;
              this.openModal(false, 'second');
            }, 2000);
          }
          if (res.data.status === "success") {
          this.getSites();
        }
        }).catch((err) => {
          // this.openModal(false);
          this.loaderBuyDomain = false;
          if (err.response.data.message) {
            this.showAlertMsg(err.response.data.message, 'alert-danger')
          }
          console.log('checkNewDomain ERROR!!!', err)
        });
        
      } else {
        console.log('No Valid Form', sendData);
        this.showAlertMsg('Not all fields are filled', 'alert-danger')
      }
    },
    setTestData(type = 'set') {
      if (type === 'set') {
        this.buyFormCardType = 'Visa';
        this.buyFormCardOwner = 'Eugene Anonymous';
        this.buyFormCardNumber = '4242424242424242';
        this.buyFormMonth = 12;
        this.buyFormYear = 2029;
        this.buyFormCvv2 = '123';
        this.buyFormAddress = '1108 Camden Street';
        this.buyFormCity = 'Reno';
        this.buyFormState = 'Nevada';
        this.buyFormZipCode = '89501';
        this.buyFormPhone = '+17752881781';
        this.buyFormCountry = 'US';

        this.buyFormRegFirstName = 'Eugene';
        this.buyFormRegLastName = 'Anonymous';
        this.buyFormRegAddress1 = '1108 Camden Street';
        this.buyFormRegCity = 'Reno';
        this.buyFormRegPostal = '89501';
        this.buyFormRegCountry = 'US';
        this.buyFormRegEmail = 'example@gmail.com';
        this.buyFormRegPhone = '+17752881781';
      } else {
        this.buyFormCardType = null;
        this.buyFormCardOwner = null;
        this.buyFormCardNumber = null;
        this.buyFormMonth = null;
        this.buyFormYear = null;
        this.buyFormCvv2 = null;
        this.buyFormAddress = null;
        this.buyFormCity = null;
        this.buyFormState = null;
        this.buyFormZipCode = null;
        this.buyFormPhone = null;
        this.buyFormCountry = null;

        this.buyFormRegFirstName = null;
        this.buyFormRegLastName = null;
        this.buyFormRegAddress1 = null;
        this.buyFormRegCity = null;
        this.buyFormRegPostal = null;
        this.buyFormRegCountry = null;
        this.buyFormRegEmail = null;
        this.buyFormRegPhone = null;
      }
      
    },
    showAlertMsg(msg, type) {
      this.checkDnsMsg = {
        msg,
        type
      }
    }
  }
}
</script>

<style lang="scss">
.embed-calcom {
  border: 1px solid red;
  min-height: 200px;
  margin-bottom: 50px;
}
.container-sites {
  padding-top: 50px;
}
.btn-switcher-mode {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
}
.table {
  position: relative;
  .empty-list {
    text-align: center;
    font-weight: bold;
    td {
      color: #757575;
    }
  }
  tbody {
    tr {
      td {
        vertical-align: middle;
        &.actions {
          text-align: center;
          .button-actions {
            border: none;
            padding: 3px 5px;
            text-decoration: underline;
            background: transparent;

            // &:first-child {
            //   margin-right: 15px;
            // }
          }
        }
        &.td-external-domain {
          .external-domain-block {
            display: flex;
            align-items: center;
          }
          .fa-check {
            color: rgb(52, 167, 3);
            font-size: 18px;
            margin-right: 4px;
          }
          .fa-triangle-exclamation {
            color: #d87127;
            font-size: 18px;
            margin-right: 4px;
          }
        }
      }
    }
  }
}

#exampleModal {
  .modal-content {
    .modal-footer {
      .btn-buy-from-edit {
        margin-right: auto;
      }
    }
  }
}

#newDomainModal {

  .form {
    .input-group-error {
      .form-select, .form-control {
        border: 1px solid red;
      }
    }
  }

  .modal-content {
    // overflow-x: hidden;

    
    .modal-body {
      
      .form-buy-data {
        max-height: 550px;
        overflow-y: auto;
        .row {
          max-width: 100%;
        }

        .modal-line {
          width: 80%;
          height: 3px;
          background: #cccccc79;
          margin: 30px auto;
        }
      }

      .domain-list {
        // border: 1px solid red;
        margin: 50px 0;
        list-style: none;
        padding: 0;
        max-height: 300px;
        overflow-y: auto;

        box-sizing: border-box;
        &::-webkit-scrollbar {
          height: 4px;
          width: 7px;
          // background: gray;
          background: rgba(203, 203, 203, 0.2);
          border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(#8DC7E1, .4);
          border-radius: 10px;
        }

        &__item {
          // border: 1px solid blue;
          margin-right: 30px;
          padding: 20px 5px;
          // padding-right: 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          transition: all .2s;
          border-bottom: 1px solid rgba(203, 203, 203, 0.5);

          & .text-domain {
            transition: all .2s;
            font-weight: bold;
            text-transform: lowercase;
          }
          &-price {
            // margin-left: auto;
            flex-grow: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .btn {
              margin: 0 0 0 30px;
            }
          }
          .pro-spinner {
            margin-right: 5px;
          }

          &:hover {
            background: rgba(209, 209, 209, .2);
          }

          &.loader-sugges {
            position: relative;
            min-height: 50px;
          }
        }
      }
    }
    .modal-footer {
      .btn-test-data {
        margin-right: auto;
      }
    }
  }
}
</style>